import * as React from 'react';
import { useEffect, useMemo } from 'react';
import { MathfieldElement } from 'mathlive';

type MathEditorProps = {
  readOnly?: boolean;
  value: string;
  onChange: (latex: string, asciiMath: string) => void;
  className?: string;
};

export const MathEditor = (props: MathEditorProps) => {
  const containerRef = React.useRef<HTMLDivElement>(null);
  const mfe = useMemo(() => new MathfieldElement({ smartMode: true, mathModeSpace: '\\:' }), []);
  mfe.readOnly = props.readOnly ?? false;

  const currentValue = React.useRef<string>('');

  useEffect(() => {
    const container = containerRef.current;
    if (!container) return;
    container.innerHTML = '';
    container.appendChild(mfe);
    mfe.className = props.className || '';

    mfe.addEventListener('input', ({ target }) => {
      const value = (target as HTMLInputElement).value || '';
      if (currentValue.current !== value) {
        currentValue.current = value;
        props.onChange(value, mfe.getValue('ascii-math'));
      }
    });
  }, []);

  useEffect(() => {
    if (currentValue.current !== props.value) {
      const position = mfe.position;
      mfe.setValue(props.value, { focus: true, feedback: false });
      mfe.position = position;
      currentValue.current = props.value;
    }
  }, [props.value]);

  return <div ref={containerRef} />;
};
